'use strict';

// Constructor
var Links = function() {
	//Links
	$('.links_item').each(function(){
		var link = $('a', this);
//		console.log(link);
		var url = link[0].hostname;
		//console.log(location.hostname, url)
		if(location.hostname.indexOf(url) >= 0 || url.indexOf("dxau.digital") >= 0){
			$('.links_item_link_internal', this).css('display','block');
		}
		else{
			$('.links_item_link_external', this).css('display','block');
			$('.links_item_link_url', this).css('display','block');
			$('a', this).attr("target","_blank");
		}
	});
}

module.exports = Links;